import { styled, css, Typography } from '@mui/material'
import { getUnitValue } from '../../../utils/processStyles'
import { TextProps } from './Text.types'

const noForwardProps = ['lineHeightAuto']

export const TextTypography = styled(Typography, {
  shouldForwardProp: (prop: string) => !noForwardProps.includes(prop)
})<TextProps>(
  ({ size, lines, lineHeightAuto }) => css`
    line-height: 1.3em;

    > b,
    > strong {
      font-weight: bold;
    }

    ${!!size &&
    css`
      font-size: ${getUnitValue(size)};
    `}

    ${!!lines &&
    css`
      display: -webkit-box;
      -webkit-line-clamp: ${lines};
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      min-height: ${lineHeightAuto
        ? 'auto'
        : css`
            ${1.3 * lines}em
          `};
    `}
  `
)

TextTypography.defaultProps = {
  color: 'text.secondary',
  variant: 'body1'
}

export default TextTypography
